/**
 * Perform operations with a maximum concurrency
 */
export default function startConcurrentPool(concurrency, data, reducer) {
    let i = 0;
    const executing = [];
    const result = [];

    const processNext = function () {
        if (i === data.length) {
            return Promise.resolve();
        }

        // Start the next operation and push it onto the result
        const p = reducer(data[i], i++);
        result.push(p);

        // Store the operation in the "executing" queue, and remove it from the
        // queue when it's completed.
        const e = p.then(function () {
            executing.splice(executing.indexOf(e), 1);
        });
        executing.push(e);

        if (executing.length >= concurrency) {
            // When max concurrency is reached, delay the next tick until the
            // first Promise in the executing queue has resolved
            return Promise.race(executing).then(processNext);
        }

        return processNext();
    };

    return processNext().then(function () {
        return Promise.all(result);
    });
}
